import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Modal } from "@template/ui";
import { useFinance } from "../FinanceContext";
import { MONTHS } from "../data/seedData";

/** Voucher-detail drill-down modal shown when a user clicks an Actual figure. */
export function VoucherModal() {
  const { voucher, closeVouchers, fmt } = useFinance();
  if (!voucher) return null;
  const { it, vouchers, scope, toM } = voucher;
  const total = vouchers.reduce((s, v) => s + v.amount, 0);

  return (
    <Modal open onClose={closeVouchers} title={`Tally Transactions — ${it.name}`} maxWidth="lg">
      <Breadcrumbs sx={{ mb: 1.5 }}>
        <Typography variant="body2">{it.dept}</Typography>
        <Typography variant="body2">{it.cc}</Typography>
        <Typography variant="body2">{it.led}</Typography>
        <Typography variant="body2">
          {scope === "cm" ? MONTHS[toM] : `Apr 2026 – ${MONTHS[toM] ?? ""}`}
        </Typography>
      </Breadcrumbs>
      <TableContainer sx={{ maxHeight: "55vh" }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Voucher No.</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Ledger</TableCell>
              <TableCell>Cost Centre</TableCell>
              <TableCell align="right">Amount</TableCell>
              <TableCell>Narration</TableCell>
              <TableCell>Version</TableCell>
              <TableCell>Uploaded</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {vouchers.length ? (
              vouchers.map((v, i) => (
                <TableRow key={v.vno + i}>
                  <TableCell sx={{ fontWeight: 600 }}>{v.vno}</TableCell>
                  <TableCell>{v.date}</TableCell>
                  <TableCell>{v.ledger}</TableCell>
                  <TableCell>{v.cc}</TableCell>
                  <TableCell align="right">{fmt(v.amount)}</TableCell>
                  <TableCell>{v.narr}</TableCell>
                  <TableCell>{v.ver}</TableCell>
                  <TableCell>{v.upload}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={8}>No transactions for this period.</TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell sx={{ fontWeight: 800 }}>TOTAL ({vouchers.length} vouchers)</TableCell>
              <TableCell colSpan={3} />
              <TableCell align="right" sx={{ fontWeight: 800 }}>
                {fmt(total)}
              </TableCell>
              <TableCell colSpan={3} />
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Modal>
  );
}
